import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "./languages/en.json";
import translationFr from "./languages/fr.json";

const resource = {
  en: {
    translation: translationEn,
  },
  fr: {
    translation: translationFr,
  }
};

i18n.use(initReactI18next).init({
  resources: resource,
  lng: "en",
  fallbackLng: "en",
  debug: true,
  keySeparator: false,
  interpolation: { escapeValue: false },
});

export default i18n;
